module.exports = __webpack_public_path__ + "images/help/icon-twr37@2x-ca9604d202d39859abd0bc3ed062b2d7.png";